import { Route, BrowserRouter, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import store, { AppState } from './state';
import { useLogin } from '@/state/base/hooks';

// import { WalletProvider } from 'contexts/Wallet';
import ToastsProvider from 'contexts/toast';

import MainRoute from './routeLayout/mainRoute';
import OtherRoute from './routeLayout/otherRoute'
import { drak, light } from './theme';

import './locale/main';

const Providers: React.FC = ({ children }) => {
    return <Provider store={store}>{children}</Provider>;
};

const StyledThemeProvider = props => {
    const base = useSelector((state: AppState) => state.base);
    return <ThemeProvider theme={base.themeMode === 'light' ? light : drak} {...props} />;
};

const ScriptService = ({ children }) => {
    const [, login] = useLogin();
    
    useEffect(() => {
        setTimeout(() => {login()},500)
    }, [login]);
    return <>{children}</>;
};

const Entry: React.ComponentType = () => {
    return (
        <Providers>
            <BrowserRouter>
                <ScriptService>
                    <StyledThemeProvider>
                        <ToastsProvider>
                            <Switch>
                                <Route path="/report" component={OtherRoute} />
                                <Route path="/signup" component={OtherRoute} />
                                <Route path="/governance-add" component={OtherRoute} />
                                <Route path="/governance-detail" component={OtherRoute} />
                                <Route path="/plan-detail" component={OtherRoute} />
                                <Route path="/node-detail" component={OtherRoute} />
                                <Route path="/" component={MainRoute} />
                                <Route path={'*'} component={MainRoute} />
                            </Switch>
                        </ToastsProvider>
                    </StyledThemeProvider>
                </ScriptService>
            </BrowserRouter>
        </Providers>
    );
};
export default Entry;
